import React from 'react'

const SelectInputTelcelContainer = (props) => {

    const [imgContent, setImgContent] = React.useState("");
    const [imgContentWidth, setImgContentWidth] = React.useState("");
    const [textContent, setTextContent] = React.useState("");

    const getImageCard = (mark) => {
        switch(mark) {
            case "1":
                return "/images/visa@3x.png";
            case "2":
                return "/images/mastercard@3x.png";
            case "3":
                return "/images/amex@3x.png";
            case "4":
                return "/images/carnet.png";
            case "999":
                return "/images/logo_n2_inbursa.png";
        }
    }

    const getImageCardWidth = (mark) => {
        switch(mark) {
            case "1":
                return "33.3px";
            case "2":
                return "33.3px";
            case "3":
                return "33.3px";
            case "4":
                return "33.3px";
            case "999":
                return "134.8px";
        }
    }

    React.useEffect(() => {
        const markNoCard = ["999","997","996"];
        const markWithCard = ["1","2","3","4","999"];

        const { mark } = props;

        setTextContent(markNoCard.includes(mark) ? "" : `******${props.value}`);
        setImgContent(markWithCard.includes(mark) ? getImageCard(mark) : "");
        setImgContentWidth(markWithCard.includes(mark) ? getImageCardWidth(mark) : "");
    }, [props.mark]);

    const styles = {
        container: {
            height: "60px",
            display: "flex",
            alignItems: "center",
            backgroundImage: "url(/images/dropdown.png)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right 10px center",
            backgroundSize: "20px 20px"
        },
        paymentMethodLabel: {
            display: "inline-block",
            fontFamily: "AMX-Bold",
            fontSize: "14px",
            color: "#222222",
            margin: "0px 16px 0px 0px"
        },
        paymentMethodTextContent: {
            display: "inline-block",
            fontFamily: "AMX-Regular",
            fontSize: "13.3px",
            color: "#222222",
            margin: "0px 0px 0px 11.7px"
        },
    }
    return (
        <div style={styles.container} onClick= {(e) =>{props.handleInputButtonFunction(e, props.input.type)}}>
            <span style={styles.paymentMethodLabel}>
                Método de pago:
            </span>

            {
                imgContent !== "" &&
                <img src={ imgContent } style={{  width: imgContentWidth }} />
            }
            
            <span style={styles.paymentMethodTextContent}>
                {textContent}
            </span>
        </div>
    )
}

export default SelectInputTelcelContainer